export class StudentNoteFilter {
	studentNumber = '';
	category = '';
	note = '';
	status = '';
	startDateFrom: Date = undefined;
	startDateTo: Date = undefined;
	endDateFrom: Date = undefined;
	endDateTo: Date = undefined;
}